import TicketsLists from 'gcs-common/components/Tickets/TicketsLists/TicketsLists';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { useIsMobile } from 'gcs-common/design-system/hooks/use-media-query';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import AgentChannelListWrapper from '../AgentChannelList/AgentChannelListWrapper/AgentChannelListWrapper';
import CraftsmanChannelList from '../CraftsmanChannelList/CraftsmanChannelList';
import NavBar from '../NavBar/NavBar';
import SidebarSettings from '../SidebarSettings/SidebarSettings';
import styles from './styles.module.scss';

const Sidebar = () => {
  const isAgent = useSelector(getIsAgent);
  const sidebarCollapsed = useSelector(getSidebarCollapsed);
  const location = useLocation();
  const { pathname } = location;
  const isTicket = pathname.includes(CHAT_ROUTES.TICKETS);
  const isMobile = useIsMobile();

  const width = useMemo(
    () => (sidebarCollapsed ? '' : isMobile ? 'w-[256px]' : 'w-[390px]'),
    [isMobile, sidebarCollapsed],
  );

  let content;
  if (isTicket) {
    content = <TicketsLists />;
  } else if (isAgent) {
    content = <AgentChannelListWrapper />;
  } else {
    content = <CraftsmanChannelList />;
  }

  return (
    <div className={`flex flex-col ${width}`}>
      <NavBar />
      {content}
      <SidebarSettings />
    </div>
  );
};

export default Sidebar;

Sidebar.propTypes = {};
